import widget from './widget'
import navigate from './navigate'
import common from './common'
import login from './login'
import theme from './theme'
import menu from './menu'
import homepage from './homepage'
import homeConfig from './home-config'
import userBehavior from './user-behavior'
import bigData from './big-data'
import home from './home'
import dataView from './data-view'
const API = {
  widget,
  navigate,
  common,
  login,
  homeConfig,
  userBehavior,
  bigData,
  home,
  theme,
  menu,
  homepage,
  dataView
}

export default API
